module.exports = __webpack_public_path__ + "img/icon_pay.9639fa97.png";